import React, { useState } from "react";
import Alert from "./Alert";

/**
 * Example usage of Alert showing each status variant, title-only vs. body,
 * a dismissible alert, a trailing action, and a custom-icon / no-icon case.
 */
const AlertExample: React.FC = () => {
	const [showDismissible, setShowDismissible] = useState(true);

	return (
		<div className="max-w-2xl space-y-6 p-2">
			<div className="space-y-3">
				<h3 className="font-medium">Variants (title + body)</h3>
				<Alert
					variant="success"
					title="Changes saved"
					description="Your invoice details were updated successfully."
					skipTranslation
				/>
				<Alert
					variant="info"
					title="Heads up"
					description="This customer belongs to a corporate group, so some fields are managed there."
					skipTranslation
				/>
				<Alert
					variant="warning"
					title="Unsaved changes"
					description="You have edits that haven't been saved yet."
					skipTranslation
				/>
				<Alert
					variant="error"
					title="Could not save"
					description="Something went wrong while saving. Please try again."
					skipTranslation
				/>
			</div>

			<div className="space-y-3">
				<h3 className="font-medium">Title only (body is optional)</h3>
				<Alert variant="success" title="All good — nothing to do here" skipTranslation />
			</div>

			<div className="space-y-3">
				<h3 className="font-medium">Dismissible</h3>
				{showDismissible ? (
					<Alert
						variant="info"
						title="Dismiss me"
						description="Click the ✕ to close this message."
						skipTranslation
						onClose={() => setShowDismissible(false)}
					/>
				) : (
					<button
						className="text-sm text-action hover:underline"
						onClick={() => setShowDismissible(true)}
					>
						Restore alert
					</button>
				)}
			</div>

			<div className="space-y-3">
				<h3 className="font-medium">With a trailing action</h3>
				<Alert
					variant="warning"
					title="Your session is about to expire"
					description="You'll be signed out in 5 minutes."
					skipTranslation
					action={
						<button className="rounded-md bg-warning/20 px-3 py-1.5 text-sm font-medium text-warning hover:bg-warning/30">
							Stay signed in
						</button>
					}
				/>
			</div>

			<div className="space-y-3">
				<h3 className="font-medium">No icon</h3>
				<Alert
					variant="info"
					title="Compact, icon-less message"
					description="Pass icon={false} to hide the leading icon."
					skipTranslation
					icon={false}
				/>
			</div>
		</div>
	);
};

export default AlertExample;
